import type { DashLightingPack } from './types';

/**
 * Current product look as a data table.
 * Swap this pack (or pass another to `resolveDashDeviceActiveSurface`) to change
 * which DS preset / colour source each category or SKU uses — without rewriting
 * status parsers.
 *
 * | category / rule | face |
 * | relay | white when on (unless mode is light/white/color) |
 * | light / lights / rgbw / bulb | light-color glow |
 * | sensor / emeter / power_meter / pv | glass glow under avatar |
 * | S4PB-00CU000002 (Cury) | light-color from ambient |
 * | else + toggle | white |
 * | else, no toggle | glass glow |
 */
export const DEFAULT_DASH_LIGHTING_PACK: DashLightingPack = {
	id: 'default',
	types: {
		'S4PB-00CU000002': { preset: 'light-color', colorFrom: 'cury-ambient' },
	},
	categories: {
		relay: { preset: 'white' },
		light: { preset: 'light-color', colorFrom: 'device' },
		lights: { preset: 'light-color', colorFrom: 'device' },
		rgbw: { preset: 'light-color', colorFrom: 'device' },
		bulb: { preset: 'light-color', colorFrom: 'device' },
		sensor: { preset: 'sensor' },
		emeter: { preset: 'sensor' },
		power_meter: { preset: 'sensor' },
		pv: { preset: 'sensor' },
	},
	modes: {
		light: { preset: 'light-color', colorFrom: 'device' },
		white: { preset: 'light-color', colorFrom: 'device' },
		color: { preset: 'light-color', colorFrom: 'device' },
	},
	refinements: {
		alertStatus: { preset: 'sensor-alert' },
		htTemperature: { colorFrom: 'ht' },
		deviceState: {
			preset: 'device-state',
			accents: {
				offline: '--color-3',
				warning: '--color-warning',
				muted: '--color-3',
			},
		},
	},
	fallback: {
		withToggle: { preset: 'white' },
		withoutToggle: { preset: 'sensor' },
	},
};
